/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import controlVersion from 'config/version.json';

export default {controlCenterVersion: controlVersion['version']};